import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { initializeBrand } from './app/shared/branding/brand.service';

// Brand BEFORE bootstrap: the brand colours must be applied before Angular's first paint.
// initializeBrand() never rejects (an unreachable API falls back to the stored/default brand).
initializeBrand()
  // eslint-disable-next-line promise/prefer-await-to-then
  .then(() => bootstrapApplication(AppComponent, appConfig))
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));
